/**
 * Answers this device gave up on before the server confirmed them
 * (docs/single-winner-answers.md): a system call ended after 10 s with no
 * word, or hung up while its answer was still out. The server may still give
 * this device the room afterwards (the answer won, late). That call is hung
 * up, not entered: the person already saw it end here.
 */
const ABANDONED_FOR_MS = 2 * 60 * 1000;
const abandoned = new Map();
/** This device gave up on its answer to the call. */
export function abandonAnswer(callId) {
    if (!callId)
        return;
    const now = Date.now();
    for (const [id, at] of abandoned) {
        if (now - at > ABANDONED_FOR_MS)
            abandoned.delete(id);
    }
    abandoned.set(callId, now);
}
/** The answer to the call was confirmed after all, or it is being answered again. */
export function keepAnswer(callId) {
    if (callId)
        abandoned.delete(callId);
}
/** Whether a room the server gives this device for the call belongs to an answer given up on (asked once). */
export function takeAbandonedAnswer(callId) {
    if (!callId)
        return false;
    const at = abandoned.get(callId);
    abandoned.delete(callId);
    return at !== undefined && Date.now() - at <= ABANDONED_FOR_MS;
}
